import React from 'react'
import LanguageSelect from '../components/Languages/LanguageSelect';

export default function Blogdropdown() {
  return (
    <LanguageSelect/>
  )
}
